(function () {
  "use strict";

  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });

    // Red de seguridad: si un salto de scroll grande (ancla, fling en móvil,
    // "volver atrás") pasa de largo un elemento sin que el observer llegue a
    // verlo entrar en pantalla, revísalo igualmente para que no se quede
    // invisible para siempre.
    var revisando = false;
    function revisarPendientes() {
      if (revisando) return;
      revisando = true;
      requestAnimationFrame(function () {
        document.querySelectorAll(".mt-reveal:not(.mt-visible)").forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            el.classList.add("mt-visible");
            obs.unobserve(el);
          }
        });
        revisando = false;
      });
    }
    window.addEventListener("scroll", revisarPendientes, { passive: true });
    window.addEventListener("resize", revisarPendientes, { passive: true });
    revisarPendientes();
  }

  function initOferta() {
    document.querySelectorAll("[data-mt-oferta]").forEach(function (barra) {
      var fechaTexto = barra.getAttribute("data-fecha-fin");
      if (!fechaTexto) return;
      var fechaFin = new Date(fechaTexto);
      if (isNaN(fechaFin.getTime())) return;
      var ocultarAlExpirar = barra.getAttribute("data-ocultar-al-expirar") === "true";
      var dias = barra.querySelector("[data-mt-oferta-dias]");
      var horas = barra.querySelector("[data-mt-oferta-horas]");
      var min = barra.querySelector("[data-mt-oferta-min]");
      var seg = barra.querySelector("[data-mt-oferta-seg]");
      if (!dias) return;

      function dosDigitos(n) { return String(n).padStart(2, "0"); }

      function tick() {
        var restante = fechaFin.getTime() - Date.now();
        if (restante <= 0) {
          if (ocultarAlExpirar) barra.style.display = "none";
          else {
            dias.textContent = horas.textContent = min.textContent = seg.textContent = "00";
          }
          clearInterval(intervalo);
          return;
        }
        var s = Math.floor(restante / 1000);
        dias.textContent = dosDigitos(Math.floor(s / 86400));
        horas.textContent = dosDigitos(Math.floor((s % 86400) / 3600));
        min.textContent = dosDigitos(Math.floor((s % 3600) / 60));
        seg.textContent = dosDigitos(s % 60);
      }

      tick();
      var intervalo = setInterval(tick, 1000);
    });
  }

  function initFiltroColeccion() {
    document.querySelectorAll("[data-mt-filtro-categoria]").forEach(function (select) {
      var seccion = select.closest(".mt-coleccion");
      if (!seccion) return;
      var grid = seccion.querySelector("[data-mt-coleccion-grid]");
      var vacio = seccion.querySelector("[data-mt-coleccion-vacio]");
      var tarjetas = grid ? grid.querySelectorAll(".mt-tarjeta") : [];

      function aplicar(valor) {
        var visibles = 0;
        tarjetas.forEach(function (tarjeta) {
          var coincide = valor === "todos" || tarjeta.getAttribute("data-mt-categoria") === valor;
          tarjeta.style.display = coincide ? "" : "none";
          if (coincide) visibles += 1;
        });
        if (vacio) vacio.hidden = visibles !== 0;
      }

      select.addEventListener("change", function () {
        aplicar(select.value);
      });

      var params = new URLSearchParams(window.location.search);
      var categoriaUrl = params.get("categoria");
      if (categoriaUrl) {
        var opcion = Array.from(select.options).find(function (o) { return o.value === categoriaUrl; });
        if (opcion) {
          select.value = categoriaUrl;
          aplicar(categoriaUrl);
        }
      }
    });
  }

  function initGalerias() {
    document.querySelectorAll("[data-mt-galeria]").forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-principal] img");
      var minis = galeria.querySelectorAll("[data-mt-mini]");
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener("click", function () {
          var src = mini.getAttribute("data-full");
          var alt = mini.getAttribute("data-alt") || "";
          if (!src) return;
          principal.setAttribute("src", src);
          principal.setAttribute("alt", alt);
          minis.forEach(function (m) { m.classList.remove("mt-activa"); });
          mini.classList.add("mt-activa");
        });
      });
    });
  }

  function money(cents, formato) {
    var valor = (cents / 100).toFixed(2).replace(".", ",");
    if (formato && formato.indexOf("{{amount}}") > -1) {
      return formato.replace("{{amount}}", valor);
    }
    return valor + " €";
  }

  function initSelectorProducto() {
    document.querySelectorAll("[data-mt-producto-form]").forEach(function (root) {
      var dataEl = root.querySelector("[data-mt-variantes]");
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var formatoPrecio = root.getAttribute("data-money-format") || "{{amount}} €";
      var idInput = root.querySelector('input[name="id"]');
      var botonComprar = root.querySelector("[data-mt-comprar]");
      var precioEl = root.querySelector("[data-mt-precio]");
      var precioComparado = root.querySelector("[data-mt-precio-comparado]");
      var avisoStock = root.querySelector("[data-mt-aviso-stock]");
      var ahorroEl = root.querySelector("[data-mt-ahorro]");
      var urgenciaEl = root.querySelector("[data-mt-urgencia-stock]");
      var grupos = root.querySelectorAll("[data-mt-opcion]");

      function seleccionActual() {
        var sel = [];
        grupos.forEach(function (grupo) {
          var activo = grupo.querySelector(".mt-seleccionada");
          sel.push(activo ? activo.getAttribute("data-valor") : null);
        });
        return sel;
      }

      function encontrarVariante(sel) {
        return variantes.find(function (v) {
          return v.opciones.every(function (val, i) { return val === sel[i]; });
        });
      }

      function actualizar() {
        var sel = seleccionActual();
        var variante = encontrarVariante(sel);
        if (!variante) return;
        if (idInput) idInput.value = variante.id;
        if (precioEl) precioEl.textContent = money(variante.precio, formatoPrecio);
        if (precioComparado) {
          if (variante.precioComparado && variante.precioComparado > variante.precio) {
            precioComparado.textContent = money(variante.precioComparado, formatoPrecio);
            precioComparado.style.display = "";
          } else {
            precioComparado.style.display = "none";
          }
        }
        if (botonComprar) {
          botonComprar.disabled = !variante.disponible;
          var botonComprarTexto = botonComprar.querySelector("span") || botonComprar;
          botonComprarTexto.textContent = variante.disponible
            ? botonComprar.getAttribute("data-texto-disponible")
            : botonComprar.getAttribute("data-texto-agotado");
        }
        if (avisoStock) {
          avisoStock.style.display = variante.disponible ? "none" : "";
        }
        if (ahorroEl) {
          if (variante.precioComparado && variante.precioComparado > variante.precio) {
            var ahorro = variante.precioComparado - variante.precio;
            ahorroEl.textContent = ahorroEl.getAttribute("data-prefijo") + " " + money(ahorro, formatoPrecio);
            ahorroEl.style.display = "";
          } else {
            ahorroEl.style.display = "none";
          }
        }
        if (urgenciaEl && urgenciaEl.getAttribute("data-activo") === "true") {
          var umbral = parseInt(urgenciaEl.getAttribute("data-umbral"), 10) || 0;
          var gestiona = variante.gestionInventario && variante.gestionInventario !== "";
          if (gestiona && variante.inventario > 0 && variante.inventario <= umbral) {
            urgenciaEl.textContent =
              urgenciaEl.getAttribute("data-texto") + " " + variante.inventario + " " + urgenciaEl.getAttribute("data-sufijo");
            urgenciaEl.style.display = "";
          } else {
            urgenciaEl.style.display = "none";
          }
        }
      }

      grupos.forEach(function (grupo) {
        grupo.querySelectorAll("[data-valor]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            if (btn.classList.contains("mt-agotada-total")) return;
            grupo.querySelectorAll("[data-valor]").forEach(function (b) {
              b.classList.remove("mt-seleccionada");
            });
            btn.classList.add("mt-seleccionada");
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function initCopiarCodigo() {
    // Delegado en document: el carrito se vuelve a pintar por AJAX (innerHTML),
    // lo que no ejecuta <script> embebidos, así que el botón necesita un
    // listener que siga funcionando aunque se reemplace el nodo del DOM.
    document.addEventListener("click", function (evt) {
      var boton = evt.target.closest("[data-mt-copiar-codigo]");
      if (!boton) return;
      var codigo = boton.getAttribute("data-mt-copiar-codigo");
      if (!boton.hasAttribute("data-texto-original")) {
        boton.setAttribute("data-texto-original", boton.textContent);
      }
      var textoOriginal = boton.getAttribute("data-texto-original");

      function marcarCopiado() {
        boton.textContent = "¡Copiado!";
        boton.setAttribute("data-copiado", "true");
        setTimeout(function () {
          boton.textContent = textoOriginal;
          boton.removeAttribute("data-copiado");
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(marcarCopiado, marcarCopiado);
      } else {
        marcarCopiado();
      }
    });
  }

  function initGuiaTallas() {
    document.addEventListener("click", function (evt) {
      if (evt.target.closest("[data-mt-abrir-guia-tallas]")) {
        var dialogo = document.querySelector("[data-mt-modal-tallas]");
        if (dialogo && dialogo.showModal) dialogo.showModal();
        return;
      }
      if (evt.target.closest("[data-mt-modal-tallas-cerrar]")) {
        var abierto = evt.target.closest("[data-mt-modal-tallas]");
        if (abierto) abierto.close();
        return;
      }
      // Clic en el backdrop nativo del <dialog>: el target es el propio <dialog>.
      if (evt.target.matches && evt.target.matches("[data-mt-modal-tallas]")) {
        evt.target.close();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initOferta();
    initFiltroColeccion();
    initGalerias();
    initSelectorProducto();
    initGuiaTallas();
    initCopiarCodigo();
  });
})();
